import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "src/components/widgets/Loader";
const Auth = lazy(() => import("./pages/auth"));
const Generator = lazy(() => import("./pages/generator"));
const GeneratorLayout = lazy(() => import("./pages/generator-layout"));
const GeneratorIndex = lazy(() => import("./pages/generator-index"));
const GeneratorBulk = lazy(() => import("./pages/generator-bulk"));
const GeneratorHistory = lazy(() => import("./pages/generator-history"));
const GeneratorExtension = lazy(() => import("./pages/generator-extension"));
const PriceAlert = lazy(() => import("./pages/priceAlert"));
const TopDeals = lazy(() => import("./pages/topDeals"));
const Account = lazy(() => import("./pages/account"));
const Support = lazy(() => import("./pages/support"));
const Privacy = lazy(() => import("./pages/privacy"));
const Extension = lazy(() => import("./pages/extension-install"));
const ForgetPass = lazy(() => import("./pages/reset-pass-pages/forgetPass"));
const NewPass = lazy(() => import("./pages/reset-pass-pages/newPass"));
const NotFound = lazy(() => import("./pages/404"));

export const useRoutes = () => {
  const renderLoader = () => (
    <div className="loader-wr">
      <Loader />
    </div>
  );

  return (
    <Suspense fallback={renderLoader()}>
      <Routes>
        <Route exact path="/login" element={<Auth join={false} />} />
        <Route path="/forget" element={<ForgetPass />} />
        <Route path="/forget/:token" element={<NewPass />} />

        {/* <Route exact path="/" element={<Generator />} /> */}
        <Route exact path="/" element={<GeneratorLayout />}>
          <Route index element={<GeneratorIndex />} />
          <Route path="bulk" element={<GeneratorBulk />} />
          <Route path="history" element={<GeneratorHistory />} />
          <Route path="extension" element={<GeneratorExtension />} />
        </Route>
        <Route exact path="/support" element={<Support />} />
        <Route exact path="/privacy" element={<Privacy />} />
        <Route exact path="/extension-download" element={<Extension />} />
        <Route path="/price-alert/:tab" element={<PriceAlert />} />
        <Route exact path="/account/:tab" element={<Account />} />
        <Route exact path="/amazon-bestbuy-walmart-top-deals" element={<TopDeals />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};
